import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';

export default function PageContainer({
  children,
  maxWidth = 1200,
  spacing = 3,
  sx = {},
  ...rest
}) {
  return (
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, md: 3 },
        py: { xs: 2.5, md: 4 },
        ...sx
      }}
      {...rest}
    >
      <Stack
        spacing={spacing}
        sx={{
          maxWidth,
          width: '100%',
          mx: 'auto'
        }}
      >
        {children}
      </Stack>
    </Box>
  );
}

PageContainer.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.number,
  spacing: PropTypes.number,
  sx: PropTypes.object
};
